import React, {ReactNode} from "react";
import {sprintf} from "sprintf-js";
import {Ergebniszeile} from "../domain/renndetails";

import "./Rennergebnisse.scss"

type RennergebnisseProps = {
    /** Liste aller Ergebnisse aus dem Rennen. */
    ergebnisse: Ergebniszeile[]
}

/**
 * Komponente welche die Ergebnisse eines Rennens in tabellarischer Form darstellt.
 */
function Rennergebnisse(props: RennergebnisseProps) {

    const header = tableHeader();
    const rows = sortiereNachPlatzierung(props.ergebnisse).map(tableRow);

    return (
        <>
            <table className="table table-striped rennergebnisse-table">
                <thead>{header}</thead>
                <tbody>{rows}</tbody>
            </table>
        </>
    );
}

function sortiereNachPlatzierung(ergebnisse: Ergebniszeile[]): Ergebniszeile[] {
    return ergebnisse.sort((a, b) => a.platzierung - b.platzierung);
}

function tableHeader(): ReactNode {
    return <tr>
        <th>Platzierung</th>
        <th>Startnummer</th>
        <th>Name</th>
        <th>Lauf 1</th>
        <th>Lauf 2</th>
        <th>Gesamt</th>
    </tr>
}

function tableRow(ergebnis: Ergebniszeile): ReactNode {
    return <tr key={ergebnis.startnummer}>
        <td>{ergebnis.platzierung}</td>
        <td>{ergebnis.startnummer}</td>
        <td>{ergebnis.name}</td>
        <td>
            <pre>
            {formatiereLauf(
                ergebnis.lauf1InSekunden,
                ergebnis.strafsekundenAusLauf1,
                ergebnis.begruendungKeineZeitAusLauf1
            )}
            </pre>
        </td>
        <td>
            <pre>
            {formatiereLauf(
                ergebnis.lauf2InSekunden,
                ergebnis.strafsekundenAusLauf2,
                ergebnis.begruendungKeineZeitAusLauf2
            )}
            </pre>
        </td>
        <td>
            <pre>
            {formatiereGesamtzeit(ergebnis.gesamtZeitInSekunden)}
            </pre>
        </td>
    </tr>
}

function formatiereLauf(fahrzeitInSekunden: number | null, strafsekunden: number | null, begruendungKeineZeit: string |
    null): string {
    if (begruendungKeineZeit != null) {
        return begruendungKeineZeit
    }

    // noinspection GrazieInspection
    if (fahrzeitInSekunden != null && strafsekunden != null) {
        // Spalten basierte Ausgabe z.B. "103,11 +   2 = 105,11"
        return sprintf('%6.2f + %3i = %6.2f', fahrzeitInSekunden, strafsekunden, fahrzeitInSekunden + strafsekunden)
    }

    return '-'
}

function formatiereGesamtzeit(gesamtZeitInSekunden: number | null) {
    if (gesamtZeitInSekunden != null) {
        return sprintf('%6.2f', gesamtZeitInSekunden)
    }

    return '-'
}

export default Rennergebnisse;
